const checkIfLocationPathStartsWith = path => {
    if (typeof location.pathname === "string") {
        return location.pathname.startsWith(path);
    }
    return location.pathname.path.startsWith(path);
};

export {checkIfLocationPathStartsWith};
